import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Stable slug for heading anchors (used by the table of contents)
export const headingId = (children) =>
  String(children)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export default function Markdown({ content }) {
  return (
    <div className="blog-prose" data-testid="markdown-content">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h2: ({ children }) => (
            <h2 id={headingId(children)} className="font-heading text-2xl md:text-3xl tracking-tight mt-12 mb-4 scroll-mt-28">{children}</h2>
          ),
          h3: ({ children }) => (
            <h3 id={headingId(children)} className="font-heading text-xl md:text-2xl tracking-tight mt-8 mb-3 scroll-mt-28">{children}</h3>
          ),
          p: ({ children }) => <p className="font-body text-[1.05rem] leading-[1.9] text-ink/80 mb-6">{children}</p>,
          a: ({ href, children }) => <a href={href} className="underline decoration-ink/30 underline-offset-4 hover:decoration-ink transition-colors" target="_blank" rel="noreferrer">{children}</a>,
          ul: ({ children }) => <ul className="list-disc pl-6 mb-6 space-y-2 font-body text-ink/80">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal pl-6 mb-6 space-y-2 font-body text-ink/80">{children}</ol>,
          blockquote: ({ children }) => (
            <blockquote className="border-l-2 border-ink pl-6 my-10 font-heading italic text-2xl md:text-3xl text-ink leading-snug">{children}</blockquote>
          ),
          img: ({ src, alt }) => (
            <figure className="my-10">
              <img src={src} alt={alt || ""} loading="lazy" className="w-full object-cover vintage-photo" />
              {alt && <figcaption className="text-center font-body text-xs text-ink/40 mt-3">{alt}</figcaption>}
            </figure>
          ),
          hr: () => <hr className="border-ink/10 my-12" />,
        }}
      >
        {content || ""}
      </ReactMarkdown>
    </div>
  );
}
